import { useVoiceAssistantStore } from '../store/useVoiceAssistantStore';

import type { PaintSurface } from './types';

/**
 * Which Voice chrome is the active paint shell.
 * Expanded (non-minimized) workspace → window; otherwise dock.
 */
export function useVoicePaintShell(): PaintSurface {
  const workspace = useVoiceAssistantStore((s) => s.workspace);
  if (workspace && !workspace.minimized) return 'window';
  return 'dock';
}
